import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// core
import {
  API_METHOD,
  SECURITY_CHECK_TYPE,
  SECURITY_CHECK_MODE,
} from 'basic/config'
import { withApi } from '_core/hocs/withApi'
import {
  privateDataActions,
  privateDataSelectors,
} from '_core/store/PrivateData'
import { ProfileSecurityFormView } from './ProfileSecurityFormView'

const mapState = state => ({
  login: privateDataSelectors.getVisitorLogin(state),
  security: privateDataSelectors.getSecurity(state),
})

const mapDispatch = {
  updateSecurity: privateDataActions.updateSecurity,
}

const RawProfileSecurityForm = props => {
  const { login, security, queue, updateSecurity } = props

  const _getSecurity = () => {
    security == null && queue(API_METHOD.CLIENT_SECURITY_INFO, {})
      .then(updateSecurity);
  }

  useEffect(_getSecurity, [])

  const [checks, setChecks] = useState({
    [SECURITY_CHECK_TYPE.AUTH]: null,
    [SECURITY_CHECK_TYPE.FINOP]: null,
  })

  const _updateChecks = () => {
    security != null &&
      setChecks({
        [SECURITY_CHECK_TYPE.AUTH]: security[SECURITY_CHECK_TYPE.AUTH].mode,
        [SECURITY_CHECK_TYPE.FINOP]: security[SECURITY_CHECK_TYPE.FINOP].mode,
      })
  }

  useEffect(_updateChecks, [security])

  const _onCheckChange = event => {
    setChecks({
      ...checks,
      [event.target.name]: event.target.value,
    })
  }

  const _initialFormState = {
    isVisible: false,
    canSubmit: null,
    submitForm: null,
  }

  const [forms, setForms] = useState({
    [SECURITY_CHECK_TYPE.AUTH]: {
      [SECURITY_CHECK_MODE.SMS]: { ..._initialFormState },
    },
    [SECURITY_CHECK_TYPE.FINOP]: {
      [SECURITY_CHECK_MODE.SMS]: { ..._initialFormState },
      [SECURITY_CHECK_MODE.FINPASSWD]: { ..._initialFormState },
    },
  })

  const _setForms = (type, mode, data) => {
    setForms({
      ...forms,
      [type]: {
        ...forms[type],
        [mode]: {
          ...forms[type][mode],
          ...data,
        },
      },
    })
  }

  const _updateForms = () => {
    security != null &&
      setForms(
        Object.keys(forms).reduce((typeResult, type) => {
          typeResult[type] = Object.keys(forms[type]).reduce(
            (modeResult, mode) => {
              modeResult[mode] = {
                ...forms[type][mode],
                isVisible: checks[type] === mode,
              }
              return modeResult
            },
            {}
          )
          return typeResult
        }, {})
      )
  }

  useEffect(_updateForms, [checks])

  const _canSubmit = type => {
    const mode = checks[type]

    if (security == null || mode == null) {
      return false
    }

    const canSubmitForm =
      forms[type][mode] == null
        ? true
        : forms[type][mode].canSubmit != null
        ? forms[type][mode].canSubmit
        : false

    return checks[type] !== security[type].mode && canSubmitForm
  }

  const _onSubmitCheck = async (type, check) => {
    return (await check()) && _onSubmit(type)
  }

  const [gauth, setGauth] = useState()

  const _onSubmit = async type => {
    const mode = checks[type]
    const values = forms[type][mode] != null ? forms[type][mode].values : {}

    try {
      // Change security check
      const result = await queue(API_METHOD.CLIENT_SECURITY_CHANGE, {
        type,
        mode,
        ...values,
      })

      if (mode === SECURITY_CHECK_MODE.AUTHKEY && result.link != null) {
        _loadAuthKey(result.link)
      }

      if (mode === SECURITY_CHECK_MODE.GAUTH && result.code != null) {
        setGauth(result)
        setIsModalOpen(true)
      }

      queue(API_METHOD.CLIENT_SECURITY_INFO, {})
        .then(updateSecurity);
    } catch (error) {
      console.log(error)
    }
  }

  const _loadAuthKey = link => {
    const anchor = document.createElement('a')
    anchor.setAttribute('href', link)
    anchor.setAttribute('type', 'text/plain')
    anchor.setAttribute('download', 'authkey.pem')
    anchor.style.display = 'none'

    document.body.appendChild(anchor)
    anchor.click()
    document.body.removeChild(anchor)
  }

  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <ProfileSecurityFormView
      forms={forms}
      login={login}
      checks={checks}
      security={security}
      gauth={gauth}
      isModalOpen={isModalOpen}
      onModalClose={() => setIsModalOpen(false)}
      setForms={_setForms}
      canSubmit={_canSubmit}
      onSubmitCheck={_onSubmitCheck}
      onCheckChange={_onCheckChange}
    />
  )
}

RawProfileSecurityForm.defaultProps = {}

RawProfileSecurityForm.propTypes = {
  // redux props
  login: PropTypes.string,
  security: PropTypes.object,
  updateSecurity: PropTypes.func.isRequired,

  // `withApi` HOC props
  addListener: PropTypes.func,
  removeAllListeners: PropTypes.func,
  queue: PropTypes.func.isRequired,
}

export const ProfileSecurityForm = withApi(
  connect(mapState, mapDispatch)(RawProfileSecurityForm)
)
